import React,{useEffect, useState} from 'react';
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import './App.css';

const App = () => {
  const [blockNumber, setBlockNumber] = useState("latest");
  const [state, setState] = useState(undefined);

  const requestBody = JSON.stringify({
    jsonrpc: '2.0',
    id: 1,
    method: 'tg_getSupply',
    params: [blockNumber]
  });

  const [formNumber, setFormNumberInternal] = useState(blockNumber);

  const setFormNumber = text => {
    if (text === 'latest') {
      setFormNumberInternal(text)
      return;
    }
    if (!isNaN(text)) {
      setFormNumberInternal(text);
      return;
    }
  }

  useEffect(() => {
    fetch('http://34.75.56.136:80', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: requestBody
    })
    .then(r => r.json())
    .then(setState)
  }, [requestBody])

  if (state === undefined) {
    return (
      <div className="App">
        <h1>loading...</h1>
      </div>
    )
  }

  if (state.error !== undefined) {
    return (
      <div className="App">
        <h1>Error</h1>
        <p>code: {state.error.code}</p>
        <p>message: {state.error["message"]}</p>
        <Button onClick={() => window.location.reload(false)}>Refresh</Button>
      </div>
    )
  }

  return (
    <div className="App">
      <Container>
      <Card className="mt-4 shadow-lg">
        <Card.Title className="mt-4">
          <h1>ETH Supply Demo</h1>
        </Card.Title>
        <Card.Body>
          <h3>ETH Supply</h3>
          <Supply supply={state.result["supply"]} />
          <h5 className="size-bg">Block</h5>
          <p>{state.result["block_number"]}</p>
          <hr />
          <h3>Check</h3>
          <Row className="mb-2">
            <Col></Col>
            <Col md={6}>
              <Form.Control type="text" value={formNumber} placeholder="block number or 'latest'" onChange={e => setFormNumber(e.target.value) } />
            </Col>
            <Col></Col>
          </Row>
          <Row>
            <Col></Col>
            <Col md={2}>
              <Button block variant="outline-primary" onClick={() => {setBlockNumber("latest"); setFormNumber("latest")}}>latest</Button>
            </Col>
            <Col md={4}>
              <Button block onClick={() => setBlockNumber(formNumber)}>check for another block</Button>
            </Col>
            <Col></Col>
          </Row>
          <hr />
          <h3>JSON-RPC Request</h3>
          <code>{requestBody}</code>
          <hr />
          <h3>Source code</h3>
          <p><a href="https://github.com/mandrigin/turbo-api-examples/tree/master/cmd/supply">github.com/mandrigin/turbo-api-examples</a></p>
        </Card.Body>
      </Card>
      <p className="mt-3 mr-3" style={{textAlign: "right", color: "grey"}}>
        made by <a style={{color: "grey", textDecorationLine:"underline"}} href="https://twitter.com/mandrigin">@mandrigin</a> | 
        powered by 🚀<a style={{color: "grey", textDecorationLine:"underline"}} href="https://github.com/ledgerwatch/turbo-geth/">TurboGeth</a>
      </p>
      </Container>
    </div>
  );
}

const Supply = ({supply}) => {
 const eth = supply.substring(0, supply.length - 18)
 const wei = supply.substring(supply.length-18, supply.length)
 return (
   <div>
    <code className="size-lg"><h2><span style={{color: 'purple'}}>{eth}</span><span style={{fontSize: '0.8em'}}>{wei}</span> wei</h2></code>
   </div>
 )
}

export default App;